import { COMPONENT_DSL_NAMES } from '@builder/schemas';

export const ELEMENTAL_LAYOUT_NODES = [
  COMPONENT_DSL_NAMES.BuilderComponentsRouteLayout,
  COMPONENT_DSL_NAMES.BuilderComponentsRoute,
  COMPONENT_DSL_NAMES.RouterSwitchSymbol,
  COMPONENT_DSL_NAMES.RootLayoutsContainer,
  COMPONENT_DSL_NAMES.BasePageLayout,
];
